"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ContainerContact_1 = require("../../containers/ContainerContact");
var Layout_1 = __importDefault(require("../Layout"));
var SectionOne_1 = require("./v2/SectionOne");
var SectionTwo_1 = require("./v2/SectionTwo");
var SectionThree_1 = require("./v2/SectionThree");
var SectionFour_1 = require("./v2/SectionFour");
var polished_1 = require("polished");
var RatesContainer_1 = require("@containers/RatesContainer");
function Main() {
    var refContact = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    function onClickGoToContact() {
        var _a;
        (_a = refContact.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }
    return ((0, jsx_runtime_1.jsxs)(Layout_1.default, { children: [(0, jsx_runtime_1.jsx)(SectionOne_1.SectionOneV2, {}), (0, jsx_runtime_1.jsxs)("div", __assign({ style: { transform: "translateY(-".concat((0, polished_1.rem)(50), ")") } }, { children: [(0, jsx_runtime_1.jsx)(SectionTwo_1.SectionTwoV2, {}), (0, jsx_runtime_1.jsx)(SectionThree_1.SectionThreeV2, {}), (0, jsx_runtime_1.jsx)(RatesContainer_1.RatesContainer, {}), (0, jsx_runtime_1.jsx)(SectionFour_1.SectionFourV2, {}), (0, jsx_runtime_1.jsx)(ContainerContact_1.ContainerContact, {})] }))] }));
}
exports.default = Main;
